import React, { useState } from "react";
import { Box, Typography, TextField, Button, Paper, Snackbar, Alert } from "@mui/material";
import { styled } from "@mui/material/styles";

const Container = styled(Box)`
  text-align: center;
  @media (max-width: 768px) {
    padding-top:3vw !important;
    margin-bottom:5vw;
  }
`;
const ContactUsTitle = styled("div")`
    color: #000;
    text-align: center;
    font-family: Montserrat;
    font-size:2.625rem ;/*42px */
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom:4vw;
    @media (max-width: 768px) {
        font-size:1.5rem ;/*24px */
        margin:8vw auto;
    }
`;

const ContentWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding:2vw 5vw 5vw ;
  border-radius: 8px;
  position: relative;
  overflow: visible;
  @media (max-width: 768px) {
    padding:2vw 7vw ;
    flex-direction: column;
  }
`;

const LeftSection = styled(Box)`
  color: #fff;
  text-align: left;
  max-width: 30%;
  @media (max-width: 768px) {
    max-width: 100%;
    text-align: center;
  }
`;

const BlueTypography = styled(Typography)`
  background-color: #1D00C4;
  color: #FFF;
  font-family: Radikal;
  font-size: 1.492rem;/*23.88px */
  font-weight: 700;
  width: 100%;
  padding:2vw 5vw ;
  text-align: start;
  @media (max-width: 768px) {
    text-align: center; 
    font-size:1.313rem ;/*21px */
    margin-bottom:10vw;
    }
`;

const Address = styled("div")`
  width: 100%;
  text-align: start;
  font-size: 21px;
  color: #414042;
  margin-bottom: 2vw; 
  &:first-of-type {
    border-top: none;
  }
  @media (max-width: 768px) {
    text-align: center; 
    font-size:1rem ;
    margin-bottom:8vw;
    }
  @media (max-width: 375px) {
    font-size:0.813rem ;/*13px */
    margin-bottom:6vw;
    }
`;

const EmailAddress = styled("div")`
  width: 100%;
  text-align: start;
  font-size: 21px;
  color: #414042;
  border-top: 1px solid #000;
  box-sizing: border-box;
  padding-top: 3vw; 
  a {
    color: inherit;
    text-decoration: none; 
    cursor: pointer;
    transition: color 0.3s ease; 
  }

  a:hover {
    color: #1a73e8; 
  }
  @media (max-width: 768px) {
    text-align: center;
    padding-top: 5vw;  
    font-size:1rem ;
    margin-bottom:5vw;
    }
  @media (max-width: 375px) {
    font-size:0.813rem ;/*13px */
    }
`;

const FormWrapper = styled(Paper)`
  padding:4vw 3vw ;
  position: absolute;
  top: 32%;
  right: 8%;
  transform: translateY(-50%);
  width: 50%;
  background: #FFF;
  border-radius: 0;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.15);
  @media (max-width: 768px) {
    position: relative;
    width: 100%;
    transform: none;
    top: auto;
    right: auto;
    padding:4vw 5vw 7vw;
  }
`;

const StyledTextField = styled(TextField)`
  margin-bottom: 10px;

  & .MuiOutlinedInput-root {
    background-color: #EDEEFF;
    border-radius: 0 !important;
    box-shadow: none;
    display: flex;
    align-items: center;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputLabel-root {
    font-family: Radikal;
    font-weight: 400;
    font-size: 12px;
    color: #696A6D;
    margin-left: 12px;
  }

  & .MuiInputBase-input {
    font-family: Radikal;
    font-weight: 400;
    font-size: 12px;
    color: #696A6D;
    height: 0.9em; 
    line-height: 1.5; 
    display: block;
  }

  & .MuiInputLabel-root.Mui-focused {
    color: #1D00C4;
  }

  & .MuiInputBase-input:focus {
    color: #333;
  }
 
`;


const StyledButton = styled(Button)`
  background-color: #1d00c4;
  color: #fff;
  padding: 0.5rem 3rem;
  text-transform: none;
  margin-top: 2rem;
  border: 0.9px solid #1d00c4;
  align-self: flex-end;
  position: relative;
  box-shadow: none;
  color: #FFF;
  text-align: center;
  font-family: Radikal;
  font-size: 1.5rem;/*24px*/
  font-weight: 500;
  border-radius: 16px !important;
  &::after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    border-radius: 15px;
    border: 3.5px solid #fff;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    position: absolute;
    bottom: -20px;
    left: 50%;
    transform: translateX(-50%);
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px; 
  }
    @media (max-width: 768px) {
    font-size:0.938rem; /*15px*/
    padding: 0.6rem 3rem;
    }
`;

const ContactUs = () => {
  const [state, setState] = useState({
    formData: {
      first_name: "",
      email: "",
      phone_number: "",
      Company: "",
      NumberOfEmployees: "",
      Industry: "",
      ExpectedMonthlyChecks: "",
      source: "Iscreening Contact Us Page"
    },
    errors: {},
    isSubmitting: false,
    notification: {
      open: false,
      message: "",
      severity: "success"
    }
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === "first_name") {
      newValue = value.replace(/[^a-zA-Z\s]/g, "").slice(0, 100);
    } else if (name === "phone_number") {
      newValue = value.replace(/[^0-9]/g, "").slice(0, 15);
    } else if (name === "email") {
      newValue = value.replace(/[^a-zA-Z0-9._%+-@]/g, "").slice(0, 100);
    }

    setState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: newValue
      },
      errors: {
        ...prev.errors,
        [name]: "" 
      }
    }));
  };

  const validateForm = () => {
    const { first_name, email, phone_number } = state.formData;
    const newErrors = {};

    if (!first_name) newErrors.first_name = "Name is required.";
    if (!email) newErrors.email = "Email is required.";
    if (!phone_number) newErrors.phone_number = "Contact number is required.";

    if (first_name && first_name.length > 100) {
      newErrors.first_name = "Name must be less than 100 characters.";
    }

    if (email && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(email)) {
      newErrors.email = "Email is invalid.";
    }

    if (phone_number && !/^\d{10,15}$/.test(phone_number)) {
      newErrors.phone_number = "Contact number must be 10-15 digits.";
    }

    setState(prev => ({ ...prev, errors: newErrors }));
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm() || state.isSubmitting) return;
    
    setState(prev => ({ ...prev, isSubmitting: true }));

    try {
      const response = await fetch("https://api.xrm.shvx.in/api/v1/lead/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer 9WFKcedIF5bV"
        },
        body: JSON.stringify(state.formData)
      });

      if (!response.ok) throw new Error('Submission failed');

      setState(prev => ({
        formData: {
          first_name: "",
          email: "",
          phone_number: "",
          Company: "",
          NumberOfEmployees: "",
          Industry: "",
          ExpectedMonthlyChecks: "",
          source: "Iscreening Contact Us Page"
        },
        errors: {},
        isSubmitting: false,
        notification: {
          open: true,
          message: "Form submitted successfully!",
          severity: "success"
        }
        
      }));
      setTimeout(() => {
        setState(prev => ({
          ...prev,
          notification: {
            ...prev.notification,
            open: false
          }
        }));
      }, 4000);
    } catch (error) {
      setState(prev => ({
        ...prev,
        isSubmitting: false,
        notification: {
          open: true,
          message: "Failed to submit form. Please try again.",
          severity: "error"
        }
      }));
      setTimeout(() => {
        setState(prev => ({
          ...prev,
          notification: {
            ...prev.notification,
            open: false
          }
        }));
      }, 4000);
    }
  };

  const handleCloseNotification = () => {
    setState(prev => ({
      ...prev,
      notification: {
        ...prev.notification,
        open: false
      }
    }));
  };

  return (
    <Container>
      <ContactUsTitle mb={2}>
        More ways to reach us
      </ContactUsTitle>
      <BlueTypography>iScreening PVT. LTD.</BlueTypography>

      <ContentWrapper>
        <LeftSection>
          <Address>
            <strong>Bangalore Office:</strong>
            <br />
            108, Ramanashree Chambers, Tasker Road, Lady Curzon Street, Bangalore - 560001.
          </Address>
          <Address>
            <strong>Gurgaon Office:</strong>
            <br />
            Villa A-410 A, Indian Airlines Pilots Society, Sushant Lok Phase I, Gurugram, Haryana 122001.
          </Address>
          <Address>
            <strong>Jaipur Office:</strong>
            <br />
            A-660, Pink Hive, Calgiri Marg Opp. Rungta Hospital, Malviya Nagar, Jaipur.
          </Address>

          <EmailAddress>
            <strong>Email:</strong>
            <br />
            <a href="mailto:iscreeningteam@iscreening.in">iscreeningteam@iscreening.in</a>
            <br />
            <a href="mailto:marketing@iscreening.in">marketing@iscreening.in</a>
          </EmailAddress>
        </LeftSection>

        <FormWrapper component="form" onSubmit={handleSubmit}>
          <StyledTextField 
            fullWidth 
            label="Full Name" 
            name="first_name"
            value={state.formData.first_name}
            onChange={handleChange}
            error={!!state.errors.first_name}
            helperText={state.errors.first_name}
          />
          
          <StyledTextField 
            fullWidth 
            label="Business Email" 
            name="email"
            value={state.formData.email}
            onChange={handleChange}
            error={!!state.errors.email}
            helperText={state.errors.email}
          />
          
          <StyledTextField 
            fullWidth 
            label="Contact Number" 
            name="phone_number"
            value={state.formData.phone_number}
            onChange={handleChange}
            error={!!state.errors.phone_number}
            helperText={state.errors.phone_number}
          />
          
          <StyledTextField 
            fullWidth 
            label="Company" 
            name="Company"
            value={state.formData.Company}
            onChange={handleChange}
          />
          
          <StyledTextField 
            fullWidth 
            label="Number of Employees" 
            name="NumberOfEmployees"
            value={state.formData.NumberOfEmployees}
            onChange={handleChange}
          />
          
          <StyledTextField 
            fullWidth 
            label="Industry" 
            name="Industry"
            value={state.formData.Industry}
            onChange={handleChange}
          />
          
          <StyledTextField 
            fullWidth 
            label="Expected Number of Checks (monthly)" 
            name="ExpectedMonthlyChecks"
            value={state.formData.ExpectedMonthlyChecks}
            onChange={handleChange}
          />
          
          <input type="hidden" name="source" value="Contact Us Page" />
          
          <StyledButton 
            variant="contained" 
            type="submit"
            disabled={state.isSubmitting}
          >
            {state.isSubmitting ? "Submitting..." : "Submit"}
          </StyledButton>
        </FormWrapper>
      </ContentWrapper>

      <Snackbar
        open={state.notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert 
          onClose={handleCloseNotification} 
          severity={state.notification.severity}
          sx={{ width: '100%' }}
        >
          {state.notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default ContactUs;